
const languageNames = new Intl.DisplayNames('nl', { type: 'language' });

export default {
  props: {
    tenderId: {
      type: String,
      required: true
    },
    tenderLanguage: {
      type: String,
      default: 'en'
    },

    enabled: {
      type: Boolean
    },

    hasData: {
      type: Boolean
    },

    loading: {
      type: Boolean
    }
  },

  computed: {
    originalLanguageName () {
      if (!this.tenderLanguage) { return 'Onbekende taal'; }

      return languageNames.of(this.tenderLanguage);
    },
    currentLanguageName () {
      return languageNames.of(this.$auth.user.iso6392T ?? 'nld');
    }
  },

  methods: {
    toggle (state) {
      this.$emit('update:enabled', state);
    }
  }
};
